export const brandInfo = {
  name: '呦呦',
  nameEn: 'YouYou',
  tagline: '源自《诗经》，归于自然',
  description: '呦呦，取自《诗经·小雅·鹿鸣》"呦呦鹿鸣，食野之苹"。我们相信，真正的美源于自然，最好的生活是与天地和谐共处。呦呦品牌致力于将千年东方美学融入现代生活，以护肤、香氛、茶品、家居四大系列产品，为追求品质生活的你打造一个诗意的日常。',
  founded: '2020年',
  location: '中国·杭州',
  slogan: '让每一天都充满呦呦之美',
};

export const brandValues = [
  { icon: 'ri-leaf-line', title: '自然纯粹', description: '以天然植物为本，拒绝化学添加，让每一款产品都是大自然的真诚馈赠。' },
  { icon: 'ri-book-open-line', title: '文化传承', description: '深耕《诗经》文化，将千年东方智慧融入产品研发，让古典美学焕发新生。' },
  { icon: 'ri-heart-line', title: '匠心品质', description: '从原料筛选到工艺打磨，每一道工序都倾注匠人的专注与热爱。' },
  { icon: 'ri-earth-line', title: '生态友好', description: '坚持可持续理念，采用环保包装，尊重自然、回馈自然是我们不变的承诺。' },
];

export const milestones = [
  { year: '2020', event: '呦呦品牌创立于杭州，推出首款护肤系列' },
  { year: '2021', event: '开设线下体验空间，获"东方美学新锐品牌"荣誉' },
  { year: '2022', event: '推出香氛系列，将《诗经》意境融入嗅觉艺术' },
  { year: '2023', event: '茶品系列上线，与云南、福建优质茶园建立合作' },
  { year: '2024', event: '家居系列面世，构建完整东方生活美学体系' },
  { year: '2025', event: '品牌全面升级，覆盖全国30+城市，服务超过50万用户' },
  { year: '2026', event: '启动"呦呦诗心"公益计划，支持传统文化保护与传承' },
];

export const honors = [
  { title: '东方美学新锐品牌', source: '中国时尚产业协会', year: '2021' },
  { title: '年度最佳国货护肤品牌', source: '美妆行业年度盛典', year: '2023' },
  { title: '绿色消费推荐品牌', source: '中国消费者协会', year: '2024' },
  { title: '最具文化价值品牌', source: '东方文化研究院', year: '2025' },
];

export const contactInfo = {
  email: 'hello@youyou.com',
  phone: '400-888-9688',
  address: '浙江省杭州市西湖区龙井路18号呦呦文化创意园',
  wechat: '呦呦生活美学',
  weibo: '@呦呦官方',
  workHours: '周一至周五 9:00-18:00',
};